<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-23 09:28:11
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-23 10:06:17
 * @FilePath: src/components/workbench-design/grid-layout/Component.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<!--
  @Author 22030124/xieyq
  @Date 2023-11-27 11:07:11
  @Description 栅格布局=》动态组件
-->
<template>
  <div
    :class="[
      scope.clsPrefix,
      { active: !readonly && selectWidget && selectWidget.i === element.i },
    ]"
    @click="handleSelect"
  >
    <!-- 动态组件 -->
    <wd-grid-layout-dynamic
      :class="`${scope.clsPrefix}_view`"
      :element="element"
      :style="{ pointerEvents: readonly ? 'auto' : 'none' }"
    />
    <div
      v-if="element.i !== 'drop' && element.data && element.data.status === 'DISABLE'"
      :class="`${scope.clsPrefix}_disabled-mask`"
    >
      <span :class="`${scope.clsPrefix}_disabled-img`"
        ><img src="@/assets/disable.png" width="120px" height="22px" alt=""></span
      >
    </div>
    <!-- 选中当前组件时生成的元素 -->
    <template v-if="!readonly && selectWidget && selectWidget.i == element.i">
      <!-- 操作 -->
      <div :class="`${scope.clsPrefix}_action`">
        <!-- 删除 -->
        <i
          :class="`${scope.clsPrefix}_btn-del`"
          class="el-icon-error"
          @click.stop="$emit('delete')"
        />
      </div>
    </template>
  </div>
</template>

<script>
// 动态组件
import WdGridLayoutDynamic from './dynamic/index.vue'
// 事件触发器
import emitter from '@/mixins/emitter.js'
export default {
  // 组件名称
  name: 'WdGridLayoutComponent',
  components: {
    WdGridLayoutDynamic
  },
  // 混入
  mixins: [emitter],
  // 依赖注入
  inject: ['select'],
  // 参数选项
  props: {
    // 当前元素
    element: Object,
    // 是否只读
    readonly: Boolean
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'wd-grid-layout-component'
      }
    }
  },
  // 计算属性
  computed: {
    // 当前选择的
    selectWidget() {
      return this.readonly ? {} : this.select() || {}
    }
  },
  // 创建完成
  created() {},
  // 挂载完成
  mounted() {},
  // 方法
  methods: {
    /**
     * 处理选择
     * @returns {void}
     */
    handleSelect() {
      this.dispatch('WorkbenchDesign', 'select-change', this.element)
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'wd-grid-layout-component';
.#{$class-prefix} {
  position: relative;
  height: 100%;
  // 视图容器
  &_view {
    position: relative;
    z-index: 2;
  }
  // 激活
  &.active {
    border: 1px solid #4a5ff3;
    padding: 10px;
    background-color: #f4f6f8;
  }
  // 操作
  &_action {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -10px;
    top: -10px;
    height: 20px;
    line-height: 20px;
    background: #fff;
    border-radius: 100%;
    z-index: 5;
    cursor: pointer;
  }
  // 删除
  &_btn-del {
    color: #4a5ff3;
    font-size: 14px;
  }
  &_disabled-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    border-radius: 4px;
    border: 1px solid #F44F4F;
  }

  &_disabled-img {
    position: absolute;
    right: 8px;
    top: 8px;
  }
}
</style>
